import React from 'react';
import Configurator from './Configurator.jsx';
import Button from './ui/button/Button.jsx';
import styles from './BapConfigurator.styl';
import Table from './ui/features/Table.jsx';
import TextInput from './ui/TextInput.jsx';
import jQuery from 'jquery'
import Image from './ui/features/Image.jsx'

/**
 * Конфигуратор Подбора БАП
 */

let powerFromServer = []
const lampFromServer = []

const LOW_LIGHT = 'Со снижением светового выхода в аварийном режиме'
const SAVE_LIGHT = 'С сохранением 100% светового выхода в аварийном режиме'


class BapConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.db = null;
		this.filter = {};

		this.state = {
			filter:{
				type:[],
				connectionType:[],
				lampSearch:'',
				power: 'Все',
			},
			items: [],
			bap: [],
			basket:[],
			itemInfo: null,
			itemBap:[],
			BapListHover:false,
			itemsPower:[],
			itemBapEmbed:[],
		};
		this.onFilter = this.onFilter.bind(this)
		this.addInfo = this.addInfo.bind(this)
		this.addBasket = this.addBasket.bind(this)
		this.onDelete = this.onDelete.bind(this)
		this.onReset = this.onReset.bind(this)
		this.onChangeQuantity = this.onChangeQuantity.bind(this)
		this.doPrint = this.doPrint.bind(this)
		this.onBtnPrintExcelClick = this.onBtnPrintExcelClick.bind(this)
		this.onMouseEnter = this.onMouseEnter.bind(this)
		this.onMouseLeave = this.onMouseLeave.bind(this)

		this.getItemList 					= this.getItemList.bind(this);
		this.getCategoryNameList 	= this.getCategoryNameList.bind(this);
		this.getPower 						= this.getPower.bind(this);
		this.getBap 							= this.getBap.bind(this);
	}

	componentDidMount() {
		const groupIdArr = [
			'10.03',
			'10.04',
			'10.05',
			'10.10'
		]
		const idPromise = groupIdArr.map(this.getItemList)
		const allProgucts = Promise.all(idPromise)

		const subGroupArray = ['10.03.01', '10.03.02', '10.04.01', '10.04.03', '10.05.01', '10.05.03',
			'10.10.02', '10.10.03', '10.10.04', '10.10.05', '10.10.06', '10.10.07'
		]

		allProgucts.then(res => {
			const result = []
			res.map(arr => {
				result.push(...arr)
			})
			result.map(({Constructor, groupId, name, art}) => {
				if(Constructor
					&& (subGroupArray.includes(groupId))
					&& (name.includes('Светильник')
					|| name.includes('Панель LED')
					|| name.includes('Панель светодиодная')
					|| name.includes('PRO Светильник')
					|| name.includes('Прожектор')
					) && !(name.includes('Прожектор ')
						&& name.includes('СДО 08-300')
					)
				){
					lampFromServer.push({
						article: art,
						name: name,
						power: this.getPower({name, art}),
						type: this.getCategoryNameList(groupId),
						bap: this.getBap(Constructor)
					})
				}
			})

			lampFromServer.map(lamp => {
				lamp.bap.map(bap => {
					if(!powerFromServer.find(item => item.article === bap.article)){
						powerFromServer.push({
							...bap
						})
					}
				})
			})
			return jQuery.getJSON(
				'itkcfg.php',
				{
					type: this.getType(),
					action: 'getItemListNSI',
					groupId: '10.06.03'
				},
				items => items);
		}).then(bapRes => {
			powerFromServer = powerFromServer.map(item => {
				const selectedBap = bapRes.find(({Code}) => Code === item.article)
				let res = {...item}
				if(selectedBap) {
					const power = selectedBap.Features.find(({Attribute}) => Attribute === 'Мощность Вт')
					let powerRes = 0
					if(power && power.value) {
						const powerArray = power.value.includes('...')
							? power.value.split('...')
							: power.value.includes('…')
								? power.value.split('…')
								: [0, 0]
						powerRes = powerArray[1]
					}
					res = {
						...res,
						power: powerRes
					}
				}
				return res
			})
			this.setState({
				bap: powerFromServer,
				items: lampFromServer,
				itemBap: powerFromServer,
				itemsPower: lampFromServer
			})
		})
	}

	getPower({name, art}){
		const regex = /(\S+)\s*Вт/;
		const arr = [2101, 2102, 2201, 2202]
		const power = name.match(regex)
				? Number(name.match(regex)[1])
				:	(isNaN(Number(art.split('-')[2]))
					? Number(art.split('-')[1])
					: Number(art.split('-')[2]))
		return arr.includes(power) ? 9 : power
	}

	getBap(powerArray){
		return powerArray.map(({optName, optArt}) => {
			if(optName && optName.includes('БАП')){
				return {
					article: optArt,
					name: optName
				}
			}
		}).filter(Boolean)
	}

	getCategoryNameList(category){

		switch (category) {
			case '10.03.01': return 'Панели светодиодные';
			case '10.03.02': return 'Светильники для торгового освещения';
			case '10.04.01': return 'Светильники пылевлагозащищенные ДСП';
			case '10.04.03': return 'Светильники для высоких пролетов';
			case '10.05.01': return 'Прожекторы светодиодные СДО';
			case '10.05.03': return 'Светильники светодиодные консольные ДКУ';
			case '10.10.02': return 'Панели светодиодные PRO';
			case '10.10.03': return 'Торговое освещение PRO';
			case '10.10.04': return 'Светильники ДСП PRO';
			case '10.10.05': return 'Светильники для высоких пролетов PRO';
			case '10.10.06': return 'Прожекторы светодиодные PRO';
			case '10.10.07': return 'Светильники консольные ДКУ PRO';
		}
	}

	getItemList(groupId){
		return jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getProductListNSI',
				groupId: groupId,
				entity: "Constructor"
			},
			items => items);
	}

	getType() {
		return 'bap';
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<Button
				x="30"
				y="780"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				disabled={!this.state.basket.length}
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="288"
				y="780"
				buttonStyle={styles.stepBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.stepBtnIcon}
				text="Сохранить в EXCEL"
				disabled={!this.state.basket.length}
				onClick={this.onBtnPrintExcelClick}
				key="printExcel"
			/>
		);

		elements.push(
			<Button
				x="547"
				y="780"

				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				disabled={!this.state.basket.length}
				onClick={this.doPrint}
				key="print"
			/>
		);

		elements.push(
			<a
				target="_blank"
				style={{
					width: '183px',
					height: '35px',
					left: '806px',
					top: '780px',
					position: 'absolute',
					textDecoration: 'none',
					color: '#334647'}}
				href={'https://www.iek.ru/products/where_to_buy/'}
			>
				<Button
					x="0"
					y="0"
					buttonStyle={styles.mainBtn}
					buttonDisabledStyle={styles.mainBtnDisabled}
					textStyle={styles.mainBtnText}
					iconStyle={styles.dwgBtnIcon}
					text='Где купить?'
					key="getBuy" />
			</a>
		);

		return elements;
	}

	onBtnPrintExcelClick() {
		this.doPrint({format: 'xls'});
	}

	doPrint(params) {
		let _params = params || {};
		_params.data = {
			speclist: JSON.stringify(this.state.basket)
		};

		super.doPrint(_params);
	}

	getCustomStyles() {
		return styles;
	}

	// добавить элемент в информацию о товаре
	addInfo (item)   {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'bap',
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				let itemBap=[]
				let itemBapEmbed = []
				let itemsBap = []
				const regex = /.*-U$/;
				if (!this.state.itemBap.includes(item)) {
					let itemBapList = this.state.bap.filter(({article}) => item.bap.find(bap => bap.article === article))
					itemBap = itemBapList.map(bapItem => {
						return {
							...bapItem,
							limit: !regex.test(bapItem.article)
						}
					})

					if(this.state.connectionType && this.state.connectionType.length !== 0){
						itemsBap = itemBap.filter(({limit}) => this.state.connectionType.includes(LOW_LIGHT) ? limit : !limit)
					}else{
						itemsBap = itemBap
					}
				}

				const photo = items[0] && (items[0].ImgJpeg || items[0].ImgPng)
				this.setState((prevState) => {
					return {
						itemInfo: {
						...item,
						photo:(photo && photo[0] && photo[0].file_ref.uri) || '',
						description:items[0] && items[0].Description[0] && items[0].Description[0].desc_ru || '',
					},
						itemBap: item.bap && item.bap.length ? itemsBap : [...prevState.itemBap],
						itemBapEmbed: item.bap && item.bap.length ? itemBapEmbed : [...prevState.itemBapEmbed],
						itemsBap
				}})
			}
		);
	}
	// добавить элемент в корзину
	addBasket(item) {
		this.setState(prevState => {
			const basket = [...prevState.basket]
			if (basket.some(i => i.article === item.article)) {
				basket.map(i => {
					if (i.article===item.article && i.article === 'LLVPOD-EPK-12-3H') { // Совместные товары, нужно добавлять парно, костыль, чтоб не ломать логику
						let addItem=basket.filter(i=> i.article === 'LDVAOD-SMD-2835-18')[0]
						addItem.count += 1
						i.count += 1
						return i
					} else if (i.article===item.article && i.article === 'LDVAOD-SMD-2835-18') {
						let addItem=basket.filter(i=> i.article === 'LLVPOD-EPK-12-3H')[0]
						addItem.count += 1
						i.count += 1
						return i
					} else
					if(i.article === item.article) {
						i.count += 1
						return i
					}
				})
			} else {
				if (item.article === 'LLVPOD-EPK-12-3H') { // Совместные товары, нужно добавлять парно, костыль, чтоб не ломать логику
				const addItem = this.state.bap.filter(i => i.article === 'LDVAOD-SMD-2835-18')[0]
				addItem.count = 1
				item.count = 1
				basket.push(item)
				basket.push(addItem)
				return {basket}
			} else if (item.article === 'LDVAOD-SMD-2835-18') {
				const addItem = this.state.bap.filter(i => i.article === 'LLVPOD-EPK-12-3H')[0]
				addItem.count = 1
				item.count = 1
				basket.push(item)
				basket.push(addItem)
				return {basket}
			}else {
				item.count = 1
				basket.push(item)
			}
			}
			this.doAddToCart(basket)
			return {basket}
		})
	}

	// удалить элемент из корзины
	onDelete(item) {
		let basket=this.state.basket
		this.setState(()=>{
			let newBasket=[]
			if(basket.some(i=> item.article===i.article && (i.article === 'LDVAOD-SMD-2835-18'|| i.article === 'LLVPOD-EPK-12-3H'))){
				newBasket=basket.filter(i=>i.article !== 'LDVAOD-SMD-2835-18'&& i.article !== 'LLVPOD-EPK-12-3H')
			}else {
				newBasket = basket.filter(i => i.article !== item.article)
			}
			this.doAddToCart(newBasket)
			return {basket: newBasket}
		})
	}

	// сборос параметров фильтра
	onReset() {
		this.setState(()=> ({
			filter: {
				type: [],
				connectionType: [],
				lampSearch: '',
				power: 'Все',
			},
			itemBap: powerFromServer,
			itemInfo: null,
			itemBapEmbed: [],
		}), (data) => {

			this.onFilter(this.state.filter)
		})

	}

	// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = [...prevState.basket]
			newBasket.map(i => {
				if (i.article === item.article) {
					if(i.article==='LDVAOD-SMD-2835-18'){
						i.count=value
						let addItem=newBasket.filter(i=> i.article === 'LLVPOD-EPK-12-3H')[0]
						addItem.count = value
						return i
					}else if(i.article==='LLVPOD-EPK-12-3H'){
						i.count=value
						let addItem=newBasket.filter(i=> i.article === 'LDVAOD-SMD-2835-18')[0]
						addItem.count = value
						return i
					}else {
						i.count = value
						return i
					}
				}

			})
			this.doAddToCart(newBasket)
			return {
				basket: newBasket
			}
		})
	}
	// фильтрация массива данных
	onFilter(filter) {
		let items = [...lampFromServer]
		let bap = [...powerFromServer]
		let itemsPower=items
		let itemInfo=null
		if (filter.type.length !== 0) {
			items = items.filter(({type}) => filter.type.some(filterType => filterType === type))
			itemsPower=items
			itemInfo = null
		}

		if (filter.lampSearch.length !== 0) {
			items = items.filter(({name, article}) =>
				name.toLowerCase().includes(filter.lampSearch.toLowerCase())
				|| article.toLowerCase().includes(filter.lampSearch.toLowerCase()))
			if (items.length !== 0) {
				this.addInfo(items[0])
			}
		}
		if (filter.power !== 'Все') {
			itemsPower = items
			items = items.filter(({power}) => +power === +filter.power)
			itemInfo = null
		}
		if (filter.connectionType.length !== 0) {
			const regex = /.*-U$/;

			items = items.filter(item => {
				return item.bap.some(lampBap => {
					const selectedBap = bap.find(bapFromServ => bapFromServ.article === lampBap.article)
					return filter.connectionType.includes(LOW_LIGHT) ? !regex.test(selectedBap.article) : regex.test(selectedBap.article)
				})
			})

			itemsPower = items
			itemInfo = this.state.itemInfo

		} else if (this.state.itemInfo !== null) {
			itemInfo = this.state.itemInfo
			this.addInfo(itemInfo)
			bap = this.state.itemsBap
		}

		const newBapArticle = []

		items.map(item => item.bap.map(i =>!newBapArticle.includes(i.article) ? newBapArticle.push(i.article) : null))
		const newBap = bap.filter(i => newBapArticle.includes(i.article))
		this.setState((prevState)=>{return {items, itemBap: newBap, itemsPower, itemInfo, connectionType:filter.connectionType,}})
	}

	onMouseEnter(){this.setState({ BapListHover: true })}
	onMouseLeave(){this.setState({ BapListHover: false })}

	render() {
		return (
			<div className={styles.cfg}>

				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '11%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Оранжевый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
					<div className={styles.title}>Конфигуратор подбора БАП</div>
				</div>

				{
					(powerFromServer.length && lampFromServer.length)
						?
						<React.Fragment>
						{/*кноки*/}
					{this.getCustomElements ? this.getCustomElements() : null}

					{/* Фильтр*/}
					<Filter
						state={this.state}
						db={this.db}
						powerFromServ={powerFromServer}
						lampFromServ={lampFromServer}
						onFilter={this.onFilter}
						onReset={this.onReset}
					/>

					{/*Список светильников */}
					<Table
						title='Выбор светильников'
						type='lampsList'
						styles={{width: '470px', top: '255px', left: '30px', height: '245px', fontSize: '10px'}}
						items={this.state.items}
						onSelect={this.addInfo}
						addBasket={this.addBasket}
						itemInfo={this.state.itemInfo}
						configType='bap'
						color='#ffc93a'
					/>

					{/*Список БАП */}
					<Table
						title='БАП соответствующий выбранному светильнику'
						type='BapList'
						styles={{width: '450px', top: '126px', left: '539px', height: '155px', fontSize: '10px'}}
						items={this.state.itemBap}
						itemsEmb={this.state.itemBapEmbed}
						onSelect={this.addInfo}
						addBasket={this.addBasket}
						itemInfo={this.state.itemInfo}
						onMouseEnter={this.onMouseEnter}
						onMouseLeave={this.onMouseLeave}
						BapListHover={this.state.BapListHover}
						configType='bap'
						color='#ffc93a'
					/>

					{/* Список спецификации */}
					<Table
						title='Корзина'
						type='Bucket'
						styles={{width: '470px', top: '554px', left: '30px', height: '169px', fontSize: ' 10px'}}
						items={this.state.basket}
						onSelect={this.addInfo}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
						configType='bap'
						color='#ffc93a'
					/>

					{/* Артикул и название */}
					{this.state.itemInfo ? (
						<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.itemInfo.article}`}
							 target="_blank">
							<div className={styles.name}>
								<div><strong>{this.state.itemInfo.name}</strong></div>
								<div><strong>{this.state.itemInfo.article}</strong></div>
							</div>
						</a>
					) : (
						<div className={styles.nameEmpty}/>
					)}

					{/* Изображение */}
					<div
						className={styles.img}
						style={this.state.itemInfo && this.state.itemInfo.photo ?
							{backgroundImage: `url(${this.state.itemInfo.photo})`, backgroundSize: 'contain'}
							: null
						}
					/>

					{/* Описание */}
					{this.state.itemInfo && this.state.itemInfo.description ? (
						<div className={styles.description}>{this.state.itemInfo.description}</div>
					) : (
						<div className={styles.descriptionEmpty}/>
					)}

							</React.Fragment>
					:

						<div>
							<svg className={styles.preloader__image} role="img" xmlns="http://www.w3.org/2000/svg"
									 viewBox="0 0 512 512">
								<path fill="currentColor"
											d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z">
								</path>
							</svg>
						</div>
				}


				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '828px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '830px'}}/>
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '828px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '831px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>

		);
	}
}

export default BapConfigurator;

class Filter extends React.Component
{
	constructor(props) {
		super(props);
		this.state = {
			itemName:'',
			lampSearch: '',
			filter: {
				lampSearch: '', // поиск по названию
				type:[], // выбранные значения фильтра
				connectionType: [], // выбранные значения фильтра
				power: 'Все' // фильтр по мощности
			},
			select: {
				type: 'Все',
				connectionType:'Все',
			}, // показ выбранного параметра
			type: [
				['Панели светодиодные'],
				['Светильники для торгового освещения'],
				['Панели светодиодные PRO'],
				['Торговое освещение PRO'],
				[
					'Промышленное освещение',
					[
						'Светильники пылевлагозащищенные ДСП',
						'Светильники для высоких пролетов',
						'Светильники ДСП PRO',
						'Светильники для высоких пролетов PRO',
					]
				],
				[
					'Уличное и архитектурное освещение',
					[
						'Прожекторы светодиодные СДО',
						'Светильники светодиодные консольные ДКУ',
						'Прожекторы светодиодные PRO',
						'Светильники консольные ДКУ PRO',
					]
				]
			], // параметры к назначеню светильника
			connectionType:[
				[LOW_LIGHT],
				[SAVE_LIGHT],
			]
		}

		this.renderType = this.renderType.bind(this)
		this.onReset = this.onReset.bind(this)
		this.renderConnectionType = this.renderConnectionType.bind(this)
		this.switchFilter = this.switchFilter.bind(this)
		this.lampSearchHandle = this.lampSearchHandle.bind(this)
	}

	switchFilter(value, type) {
		const state = this.state
		const filter = this.state.filter
		filter[type] = []

		switch (value) {
			case 'Все':
				break
			case 'Коммерческое освещение':
				filter.type.push(...state.type[0])
				filter.type.push(...state.type[1])
				filter.type.push(...state.type[2])
				filter.type.push(...state.type[3])
				break
			case 'Панели светодиодные':
				filter.type.push(...state.type[0])
				break
			case 'Светильники для торгового освещения':
				filter.type.push(...state.type[1])
				break
			case 'Панели светодиодные PRO':
				filter.type.push(...state.type[2])
				break
			case 'Торговое освещение PRO':
				filter.type.push(...state.type[3])
				break
			case 'Промышленное освещение':
				filter.type.push(...state.type[4][1])
				break
			case 'Уличное и архитектурное освещение':
				filter.type.push(...state.type[5][1])
				break
			case LOW_LIGHT:
				filter.connectionType.push(state.connectionType[0][0])
				break
			case SAVE_LIGHT:
				filter.connectionType.push(state.connectionType[1][0])
				break
			default:
				filter.type.push(value)
				break
		}
		filter.power='Все'
		this.setState(prevState => {
			return {select:{...prevState.select, [type]: value}, filter}
		})
		this.props.onFilter(filter)
	}

	lampSearchHandle (e) {
		this.setState(prevState => {
			return {
				filter: {...prevState.filter, lampSearch: e }
			}
		}, () => this.props.onFilter(this.state.filter))
	}

	powerHandle (e) {
		this.setState(prevState => {
			return {
				filter: {...prevState.filter, power: e }
			}
		}, () => this.props.onFilter(this.state.filter))
	}

	powerType () {
		const collection = []
		this.props.state.itemsPower.forEach(({power}) => {
			if(power && !collection.includes(+power)) {
				collection.push(+power)
			}
		})
		collection.sort((a, b) => a - b)

		return (
			<select
				className={styles.powerSelect}
				onChange={e => this.powerHandle(e.target.value)}
				value={this.state.filter.power}>
				<option value='Все'>Все</option>
				{collection.map(item => <option key={item} value={item}>{item}</option>)}
			</select>
		)
	}

	renderType(settings) {
		return (
			<li className={styles.Li}>

				<span onClick={() => this.switchFilter(settings[0],'type')} className={styles.Span}>{settings[0]}</span>

				<ul className={styles.Ul}>

					{ Array.isArray(settings[1]) &&
						settings[1].map((item,i) => <li key={i} className={styles.Li}>
						<span onClick={() => this.switchFilter(item, 'type')} className={styles.Span}>{item}</span>
					</li>)
					}

				</ul>
			</li>
		)
	}

	renderConnectionType() {
		return (
			<select
			  name={'connectionType'}
				className={styles.Select}
				onChange={e => this.switchFilter(e.target.value,'connectionType')}
				value={this.state.select.connectionType}>
				<option value={'Все'}>Все</option>
				{this.state.connectionType.map((item,i) => <option key={i} value={item[0]}>{item[0]}</option>)}
			</select>
		)
	}

	onReset() {
		this.setState({
			lampSearch: '',
			filter: {
				lampSearch: '',
				type:[],
				connectionType: [],
				power: 'Все'
			},
			select: {
				type: 'Все',
				connectionType:'Все',
			}
		}, () => {
			this.props.onReset()
			// this.switchFilter('Все', 'type')
			// this.switchFilter('Все', 'connectionType')
		})

	}

	render() {
		return (
			<div className={styles.FilterBlock}>

				{/*назначение светильника*/}
				<div className={styles.selectType}>
					<span className={styles.selectTypeTitle}>Назначение светильника:</span>
					<ul className={styles.selectTypeUl}>

						<li className={styles.selectTypeLi}><span className={styles.Span}>{this.state.select.type}</span>

							<ul className={styles.Ul}>

								<li className={styles.Li}>
									<span className={styles.Span} onClick={() =>this.switchFilter('Все', 'type')}>Все</span>
								</li>

								<li className={styles.Li}>
									<span
										className={styles.Span}
										onClick={() =>this.switchFilter('Коммерческое освещение', 'type')}>
										Коммерческое освещение
									</span>

									<ul className={styles.Ul}>
										{this.renderType(this.state.type[0])}
										{this.renderType(this.state.type[1])}
										{this.renderType(this.state.type[2])}
										{this.renderType(this.state.type[3])}
									</ul>

								</li>

								{this.renderType(this.state.type[4])}
								{this.renderType(this.state.type[5])}

							</ul>
						</li>
					</ul>
				</div>

				{/*тип подключения*/}
				<div className={styles.SelectConnectionType}>
					<span className={styles.selectConnectionTypeTitle}>Вариант подключения:</span>
					{this.renderConnectionType()}
				</div>

				{/*поиск светильника*/}
				<span className={styles.lampSearchTitle}>Поиск светильника:</span>
				<TextInput
					x={10} y={85} width={200}
					value={this.state.filter.lampSearch}
					onChange={this.lampSearchHandle}
					key={'findArticle'}
				/>

				{/*мощность*/}
				<div className={styles.powerType}>
					<span className={styles.powerTypeTitle}>Мощность Вт:</span>
					{this.powerType()}
				</div>

				{/*кнопка сброса параметров*/}
				<button className={styles.ResetButton} onClick={this.onReset}>Сбросить фильтр</button>

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/react/BapConfigurator.jsx